if (!customElements.get('minima-waitlist')) {
  customElements.define(
    'minima-waitlist',
    class MinimaWaitlist extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.productForm = this.parentElement.querySelector('product-form');
        this.submitButton = this.productForm?.querySelector('[name="add"]');
        this.trigger = this.querySelector('[data-waitlist-open]');
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        if (!this.productInfo || !this.submitButton || !this.trigger || !this.dialog || !this.form) return;

        this.onClick = (event) => {
          const action = event.target.closest('[data-waitlist-open], [data-waitlist-close]');
          if (!action || !this.contains(action)) return;
          if (action.hasAttribute('data-waitlist-close')) {
            this.dialog.close();
          } else if (!this.trigger.hidden && !this.trigger.disabled) {
            this.openDialog(event.detail === 0);
          }
        };
        this.addEventListener('click', this.onClick);

        this.onKeyDown = (event) => {
          if (event.key === 'Tab') this.dialog.setAttribute('data-keyboard-navigation', '');
        };
        this.dialog.addEventListener('keydown', this.onKeyDown);

        this.onClose = () => {
          if (!this.dialog.hasAttribute('data-keyboard-navigation')) this.trigger.blur();
        };
        this.dialog.addEventListener('close', this.onClose);

        this.onBackdropClick = (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (
            event.clientX < bounds.left || event.clientX > bounds.right ||
            event.clientY < bounds.top || event.clientY > bounds.bottom
          ) this.dialog.close();
        };
        this.dialog.addEventListener('click', this.onBackdropClick);

        this.unsubscribeSelection = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
          if (!this.productInfo.contains(data.event.target)) return;
          this.trigger.disabled = true;
          this.trigger.setAttribute('aria-busy', 'true');
          this.dialog.close();
        });
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.productInfo.dataset.section) return;
          const sourceButton = data.html.getElementById(`ProductSubmitButton-${data.sectionId}`);
          this.syncVariant(data.variant, sourceButton?.hasAttribute('disabled') ?? true);
        });

        this.syncVariant(
          { id: this.dataset.variantId, title: this.dataset.variantTitle },
          this.dataset.soldOut === 'true'
        );
        if (this.form.querySelector('[data-waitlist-feedback]') && window.location.hash === `#${this.form.id}`) {
          this.openDialog();
        }
      }

      disconnectedCallback() {
        this.unsubscribeSelection?.();
        this.unsubscribeVariant?.();
        this.removeEventListener('click', this.onClick);
        this.dialog?.removeEventListener('click', this.onBackdropClick);
        this.dialog?.removeEventListener('keydown', this.onKeyDown);
        this.dialog?.removeEventListener('close', this.onClose);
        if (this.dialog?.open) this.dialog.close();
      }

      openDialog(keyboardNavigation = false) {
        // Safari doesn't always focus tapped buttons; set the native dialog's return target.
        if (!this.trigger.hidden) this.trigger.focus({ preventScroll: true });
        this.dialog.toggleAttribute('data-keyboard-navigation', keyboardNavigation);
        this.dialog.showModal();
      }

      syncVariant(variant, soldOut) {
        this.trigger.disabled = false;
        this.trigger.removeAttribute('aria-busy');
        const canJoin = Boolean(variant?.id) && soldOut;
        this.trigger.hidden = !canJoin;
        this.submitButton.classList.toggle('minima-waitlist__original-hidden', canJoin);
        this.productForm.toggleAttribute('data-waitlist-active', canJoin);
        if (!variant?.id) return;

        this.querySelector('[data-waitlist-variant-id]').value = variant.id;
        this.querySelector('[data-waitlist-variant-title]').value = variant.title;
        const productUrl = new URL(this.dataset.productUrl, window.location.origin);
        productUrl.searchParams.set('variant', variant.id);
        this.querySelector('[data-waitlist-product-url]').value = productUrl.href;
        productUrl.hash = this.form.id;
        this.form.querySelector('[name="return_to"]').value = productUrl.pathname + productUrl.search + productUrl.hash;
      }
    }
  );
}
